<template>
    <div>
    </div>
</template>

<script>
import { getRoom } from "@/entities/Room"

// router.push(`/next-lector/${233}/stand`)

export default {
        async mounted() {
            const room_date_ids = {
                '2025-9-7': 233, // 44
                '2025-9-8': 249, // 45
                '2025-9-9': 255, // 46
            };
        const date = new Date();
        // const room = await getRoom(room_date_ids?.[`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`] ?? 44, true);
        // console.log('room', room?.lectures?.[0]?.id);
        this.$router.push(`/next-lector/${room_date_ids?.[`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`] ?? 299}/stand`);
    }
}

</script>